import ReactGA from "react-ga4";

ReactGA.initialize("G-X68HNWZG5X");

// Minimal analytics hook for essential tracking
export const useAnalytics = () => {
    // Log a custom event
    const logEvent = async (name: string, params?: Record<string, any>) => {
        ReactGA.event(name, params);
    };

    // Set the current screen
    const setCurrentScreen = async (path: string, screenClassOverride?: string) => {
        ReactGA.send({ hitType: "pageview", page: path, title: screenClassOverride });
    };

    return {
        logEvent,
        setCurrentScreen,
    };
};